import { FC } from 'react';
import { useNetworkRecovery } from '../hooks/useNetworkRecovery';

/**
 * Component that manages network recovery events.
 * Must be placed inside Redux Provider context.
 */
export const NetworkRecoveryManager: FC = () => {
  // Initialize network recovery handling
  useNetworkRecovery();
  
  // This component renders nothing but provides network recovery functionality
  return null;
};